import { useMemo } from "react";
import {
  useStudyingNow,
  type StudyingPresence,
} from "@/contexts/StudyingNowContext";
import type { ActiveUser } from "@/hooks/use-active-users";

export interface StudyingUser extends ActiveUser {
  topicTitle?: string | null;
  sessionSlug?: string | null;
  bannerUrl?: string | null;
  category?: string | null;
}

export const useStudyingUsers = () => {
  const { presenceState, userId } = useStudyingNow();

  const studyingUsers = useMemo(() => {
    const users: StudyingUser[] = [];
    presenceState.forEach((presence: StudyingPresence) => {
      users.push({
        userId: presence.userId,
        email: presence.email,
        avatarUrl: presence.avatarUrl,
        displayName: presence.displayName ?? undefined,
        // AvatarGroup / ActiveUsersPopover expect `joinedAt`.
        joinedAt: presence.startedAt,
        topicTitle: presence.topicTitle,
        sessionSlug: presence.sessionSlug,
        bannerUrl: presence.bannerUrl ?? null,
        category: presence.category ?? null,
      });
    });
    return users;
  }, [presenceState]);

  const studyingCount = studyingUsers.length;

  return {
    studyingUsers,
    studyingCount,
    // The current user's own id, so consumers can exclude themselves if desired.
    currentUserId: userId,
  };
};
